import {
  FunctionComponent,
  MouseEventHandler,
  ReactElement,
  useEffect,
  useState,
} from 'react';
import { useMeasure } from 'react-use';

import { BUTTON_TYPES } from '@savgroup-front-common/constants';
import { MessageType } from '@savgroup-front-common/types';

import {
  safeFormattedIntlString,
  SafeFormattedMessage,
} from '../../formatters';
import { useIsNewUiEnabled } from '../../hooks/useIsNewUiEnabled';

import {
  $FieldLabel,
  $FieldLabelNewUi,
  $LabelContainer,
  $SpannedButton,
} from './Field.styles';
import { FIELD_ALIGN } from './Field.types';

interface FieldLabelProps {
  label?: string | number | MessageType;
  labelIcon?: ReactElement | undefined;
  labelIconAlign?: FIELD_ALIGN;
  align?: FIELD_ALIGN;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const FieldLabel: FunctionComponent<FieldLabelProps> = ({
  label = undefined,
  labelIcon = undefined,
  labelIconAlign = FIELD_ALIGN.LEFT,
  align = FIELD_ALIGN.LEFT,
  onClick,
}) => {
  const isNewUi = useIsNewUiEnabled();
  const [measuredWidth, setMeasuredWidth] = useState<number>(0);
  const [ref, { width }] = useMeasure<HTMLDivElement>();

  useEffect(() => {
    if (measuredWidth === 0) {
      setMeasuredWidth(width);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);

  if (!label) {
    return <></>;
  }

  if (isNewUi) {
    return (
      <$FieldLabelNewUi $align={align} title={safeFormattedIntlString(label)}>
        <$SpannedButton
          type={BUTTON_TYPES.BUTTON}
          onClick={onClick}
          ref={ref as any}
          $containerWidth={measuredWidth}
        >
          {labelIcon && labelIconAlign === FIELD_ALIGN.LEFT && (
            <$LabelContainer $align={labelIconAlign}>
              {labelIcon}
            </$LabelContainer>
          )}
          {SafeFormattedMessage(label)}
          {labelIcon && labelIconAlign === FIELD_ALIGN.RIGHT && (
            <$LabelContainer $align={labelIconAlign}>
              {labelIcon}
            </$LabelContainer>
          )}
        </$SpannedButton>
      </$FieldLabelNewUi>
    );
  }

  return (
    <$FieldLabel $align={align}>
      <$SpannedButton
        type={BUTTON_TYPES.BUTTON}
        onClick={onClick}
        $containerWidth={width}
      >
        {labelIcon && labelIconAlign === FIELD_ALIGN.LEFT && (
          <$LabelContainer $align={labelIconAlign}>{labelIcon}</$LabelContainer>
        )}
        {SafeFormattedMessage(label)}
        {labelIcon && labelIconAlign === FIELD_ALIGN.RIGHT && (
          <$LabelContainer $align={labelIconAlign}>{labelIcon}</$LabelContainer>
        )}
      </$SpannedButton>
    </$FieldLabel>
  );
};

FieldLabel.displayName = 'FieldLabel';

export default FieldLabel;
